/* eslint-disable */
import React from 'react'
import { QuanticProvider, GlobalStyles } from 'quantic'

function RootComponents({ children }) {
  return (
    <QuanticProvider auth layout>
      <GlobalStyles />
      {children}
    </QuanticProvider>
  )
}

export default RootComponents
